
<wiz-vgroup horizontalAlign="center" width="100%" height="100%" style="padding-right: 3px;">
    <wiz-vgroup width="100%" horizontalAlign="center" class="window" style="padding-top: 10px; padding-bottom: 10px;">

        <wiz-hgroup width="100%" verticalAlign="center" horizontalAlign="center">
            <wiz-icon class="basicIcon black hover" [wizTooltip]="'$.common.home.$'" tooltipPlacement="right" (click)="go('home')">
                <mat-icon>home</mat-icon></wiz-icon>
            <wiz-label *ngIf="showLabel()" [ngStyle]="{'width':perfectWidth}" [wizTextBehavior]="'truncate'" [wizLabel]="'$.common.home.$'" class="componentLabel"></wiz-label>  
        </wiz-hgroup>
       
        
        <wiz-hgroup width="100%" verticalAlign="center" horizontalAlign="center">
            <wiz-icon class="basicIcon red hover" [wizTooltip]="'$.cv.title.$'" tooltipPlacement="right" (click)="go('cv')">
            <mat-icon>people_alt</mat-icon></wiz-icon>
            <wiz-label *ngIf="showLabel()" [ngStyle]="{'width':perfectWidth}" [wizTextBehavior]="'truncate'" [wizLabel]="'$.cv.title.$'" class="componentLabel"></wiz-label>  
        </wiz-hgroup>
        
        <wiz-hgroup width="100%" verticalAlign="center" horizontalAlign="center">
            <wiz-icon class="basicIcon red hover" [wizTooltip]="'$.cv.mass.title.$'" tooltipPlacement="right" (click)="go('masscv')">
            <mat-icon>group_add</mat-icon></wiz-icon>
            <wiz-label *ngIf="showLabel()" [ngStyle]="{'width':perfectWidth}" [wizTextBehavior]="'truncate'" [wizLabel]="'$.cv.mass.title.$'" class="componentLabel"></wiz-label>  
        </wiz-hgroup>


        <wiz-hgroup width="100%" verticalAlign="center" horizontalAlign="center">
            <wiz-icon class="basicIcon blue hover" [wizTooltip]="'$.job.title.$'" tooltipPlacement="right" (click)="go('job')">
            <mat-icon>work</mat-icon></wiz-icon>
            <wiz-label *ngIf="showLabel()" [ngStyle]="{'width':perfectWidth}" [wizTextBehavior]="'truncate'" [wizLabel]="'$.job.title.$'" class="componentLabel"></wiz-label>  
        </wiz-hgroup>
        
        <wiz-hgroup width="100%" verticalAlign="center" horizontalAlign="center">
            <wiz-icon class="basicIcon blue hover" [wizTooltip]="'$.job.mass.title.$'" tooltipPlacement="right" (click)="go('massjob')">
            <mat-icon>cases</mat-icon></wiz-icon>
            <wiz-label *ngIf="showLabel()" [ngStyle]="{'width':perfectWidth}" [wizTextBehavior]="'truncate'" [wizLabel]="'$.job.mass.title.$'" class="componentLabel"></wiz-label>  
        </wiz-hgroup>

        
        <wiz-hgroup width="100%" verticalAlign="center" horizontalAlign="center">
            <wiz-icon class="basicIcon black hover" [wizTooltip]="'$.ai.questions.$'" tooltipPlacement="right" (click)="go('questions')">
            <mat-icon>support_agent</mat-icon></wiz-icon>
            <wiz-label *ngIf="showLabel()" [ngStyle]="{'width':perfectWidth}" [wizTextBehavior]="'truncate'" [wizLabel]="'$.ai.questions.$'" class="componentLabel"></wiz-label>  
        </wiz-hgroup>
        
        <wiz-hgroup width="100%" verticalAlign="center" horizontalAlign="center">
            <wiz-icon class="basicIcon black hover" [wizTooltip]="'$.match.title.$'" tooltipPlacement="right" (click)="go('match')">
            <mat-icon>join_right</mat-icon></wiz-icon>
            <wiz-label *ngIf="showLabel()" [ngStyle]="{'width':perfectWidth}" [wizTextBehavior]="'truncate'" [wizLabel]="'$.match.title.$'" class="componentLabel"></wiz-label>  
        </wiz-hgroup>

    </wiz-vgroup>

    <wiz-spacer height="20px"></wiz-spacer>


</wiz-vgroup>


